<template>
  <div class="home position-relative">
    <Header/>
    <About @showFixedNav="$emit('showFixedNav')" @hideFixedNav="$emit('hideFixedNav')"/>
    <Helping v-if="itemSize"/>
    <HelpingCarousel v-else/>
    <Provide/>
    <Comments/>
    <Questions/>
    <go-record/>
    <Articles/>
    <Footer/>
  </div>
</template>
<script>

  import Header from '@/views/Home/components/Header';
  import About from '@/views/Home/components/About';
  import Helping from '@/views/Home/components/Helping';
  import HelpingCarousel from '@/views/Home/components/HelpingCarousel';
  import Provide from '@/views/Home/components/Provide';
  import Comments from '@/views/Home/components/Comments';
  import Questions from '@/views/Home/components/Questions';
  import GoRecord from '@/views/Home/components/GoRecord';
  import Articles from '@/views/Home/components/Articles';
  import Footer from '@/views/Home/components/Footer';
  export default {
    metaInfo: {
      title: 'Главная'
    },
    name: 'Home',
    components: {
      Header,
      About,
      Helping,
      HelpingCarousel,
      Comments,
      Provide,
      Questions,
      GoRecord,
      Articles,
      Footer
    },
    data() {
      return {
        itemSize: null,
        loading: true
      }
    },
    methods: {
      onResize() {
        this.itemSize = document.documentElement.clientWidth > 930 ? true : false;
      },
      getScrollPosition() {
        const html = document.documentElement;
        const body = document.body;
        const about = document.getElementById('about').offsetTop
        var scrollTop = html.scrollTop || body && body.scrollTop || 0;
        if(scrollTop < about) {
          this.$emit('darkNav')
        } else this.$emit('whiteNav')
      }
    },
    mounted() {
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.getScrollPosition)
      this.onResize();
      this.getScrollPosition();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.getScrollPosition)
      this.$emit('whiteNav')
    },
  }
</script>
<style lang="scss">
  * {
    outline: none !important;
  }
  a {
    text-decoration: none !important;
  }
  .home {
    max-width: 1920px ;
    margin-left: auto;
    margin-right: auto;
  }
  .title {
    font-size: 32px;
    text-align: center;
    color: #1f1f1f;
    font-family: 'Comfortaa', cursive;
    margin-top: 20px;
    margin-bottom: 73px;
  }
  .dots {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  .mt-24 {
    margin-top: 24px;
  }


  .consultation {
    font-family: 'Raleway', sans-serif;
    padding: 32px;
    display: flex;
    flex-wrap: wrap;
    p {
      width: 100%;
      font-size: 17px;
      color: #7e7e7e;
      font-weight: 300;
      line-height: normal;
      margin-bottom: 16px;
    }
    span {
      width: 100%;
      font-size: 24px;
      font-weight: 600;
      color: #1f1f1f;
      margin-top: 0;
      line-height: 1;
    }
  }
  .card-title {
    span {
      font-size: 17px;
      color: #ffffff;
      margin-bottom: 0;
      margin-top: 16px;
    }
  }
  @media screen  and (max-width: 550px){
    .title {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.47;
    }
  }
</style>